// library imports
import { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
// import { ToastContainer } from "react-toastify";

// project imports
import { FeaturesRouter } from './features/routers/FeaturesRouter';
import AutoReload from '../src/features/components/auto-reload/AutoReload';
import { initFbPixel, trackPageView } from 'shared/settings/fbPixelConfig';

import * as CookieConsent from "vanilla-cookieconsent";
import ccConfig from "./cookieconsent-ui";

// style imports
import './App.scss';
import HeartBeat from 'features/components/base/public/heartbeat/HeartBeat';

export class App extends Component {

    // constructor(props) {
    //     super(props);
    // }

    componentDidMount() {
      // Initialize Vanilla Cookie Consent
      CookieConsent.run(ccConfig);
    
      // listen for consent change
      window.addEventListener("cc:onChange", this.handleConsent);
    
      // check once on load
      this.handleConsent();
    }
    
    handleConsent = () => {
      const targetingAllowed = CookieConsent.acceptedCategory("targeting");
    
      if (targetingAllowed && !window.fbPixelLoaded) {
        initFbPixel();
        trackPageView();
        window.fbPixelLoaded = true;
      }
    };

    render() {
        return (
            <div data-testid="app-comp" className="w-100 h-100" style={{ overflowX: "hidden" }}>
                {/* <ToastContainer /> */}
                <Router>
                    {
                        window.location.href.includes("/heartbeat") ? 
                            <Route exact path="/heartbeat" component={HeartBeat} /> : 
                            <Route component={FeaturesRouter} />
                    }   
                </Router>
                <AutoReload url="/index.html" forceReload />
            </div>
        );
    }
}

// export default withRouter(App);